<div
  class="px-6 h-16 border-b sticky left-0"
  [ngClass]="{ 'bg-white': backgroundColorWhite, 'bg-app-bar': !backgroundColorWhite }"
  fxLayout="row"
  fxLayoutAlign="start center"
>
  <div *ngFor="let dt of dynamicTemplatesBefore" [permissionBlock]="dt.hasPermission">
    <ng-container *ngIf="dt.isShowing !== false">
      <ng-container [ngTemplateOutlet]="dt.template"></ng-container>
    </ng-container>
  </div>

  <span fxFlex></span>

  <div *ngFor="let dt of dynamicTemplatesAfter" [permissionBlock]="dt.hasPermission">
    <ng-container *ngIf="dt.isShowing !== false">
      <ng-container [ngTemplateOutlet]="dt.template"></ng-container>
    </ng-container>
  </div>
</div>
